<h2 mat-dialog-title>
  {{ config.action === 'delete' ? ('confirmar_exclusao' | transloco) : config.action === 'new-list' ?
  ('criar_nova_lista' | transloco)
  :
  config.action ==='rename'? ('renomear_lista' | transloco):('excluir_produto' | transloco) }}
</h2>
<mat-dialog-content>
  <ng-container *ngIf="config.action === 'delete'">
    <p>{{'excluir_lista_confirmacao' | transloco}} "{{ config.list.name }}"?</p>
  </ng-container>
  <ng-container *ngIf="config.action === 'delete-product'">
    <p>{{'excluir_produto_confirmacao' | transloco}} "{{ config.productName }}"?</p>
  </ng-container>
  <ng-container *ngIf="config.action === 'rename'">
    <mat-form-field appearance="fill">
      <mat-label>{{'novo_nome_lista' | transloco}}</mat-label>
      <input matInput [formControl]="nameControl" placeholder="{{'nome_nova_lista' | transloco}}">
      <mat-error *ngIf="nameControl.hasError('required')">
        {{"nome_lista_obrigatorio" | transloco}}
      </mat-error>
      <mat-error *ngIf="nameControl.hasError('maxlength')">
        {{'nome_max_caracteres' | transloco}}
      </mat-error>
    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="config.action === 'new-list'">
    <mat-form-field appearance="fill">
      <mat-label>{{'nome_lista' | transloco}}</mat-label>
      <input matInput [formControl]="nameControl" placeholder="{{'digite_nome_lista' | transloco}}">
      <mat-error *ngIf="nameControl.hasError('required')">
        {{"nome_lista_obrigatorio" | transloco}}
      </mat-error>
      <mat-error *ngIf="nameControl.hasError('maxlength')">
        {{'nome_max_caracteres' | transloco}}
      </mat-error>
    </mat-form-field>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="onCancel()">{{ 'cancelar' | transloco }}</button>
  <button type="button" mat-raised-button
    [color]="(config.action === 'delete' || config.action === 'delete-product' ) ? 'warn' : 'primary'"
    (click)="onConfirm()"
    [disabled]="(config.action === 'rename' || config.action === 'new-list')  && nameControl.invalid">
    {{ config.action === 'rename' ? ('renomear' | transloco) : config.action === 'new-list' ? ('criar' | transloco) :
    ('excluir' |
    transloco) }}
  </button>
</mat-dialog-actions>